<div class="container mb-4">
    <ngb-carousel #carousel [showNavigationIndicators]="true" interval="2500" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
        <ng-template *ngFor="let testimonial of testimonials; index as i" class="col-4" data-aos="fade-up"
                     data-aos-delay="400"
                     data-aos-duration="1000" data-aos-easing="bounce" ngbSlide>
            <div class="row flex justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="300"
                 data-aos-duration="1000"
                 data-aos-easing="bounce">
                <div [ngClass]="{'col': testimonial.image?.link, 'col-12 text-center': !testimonial.image?.link}"
                     class="mt-lg-3" id="testimonial-content-{{i}}">
                    <img class="img-fluid" src="assets/images/quote.svg">
                    <h3 class="fw-bold fst-italic px-1 testimonial-text"
                        [ngClass]="{'text-start': testimonial.image?.link, 'text-center': !testimonial.image?.link}">
                        {{ testimonial.message }}
                    </h3>
                    <p [ngClass]="{'text-start': testimonial.image?.link, 'text-center': !testimonial.image?.link}">
                        {{ testimonial.name }}, {{ testimonial.country }}
                    </p>
                </div>
                <div class="col-4" *ngIf="testimonial.image?.link">
                    <img [src]="testimonial.image.link"
                         (error)="onImageError($event, i)"
                         class="rounded-circle img-thumbnail" style="max-height: 200px">
                </div>
            </div>

        </ng-template>
    </ngb-carousel>
</div>
